// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import storage from './service/storage-service'
import {
  Message
} from 'element-ui';
import router from './router'
import elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import http from './http'
import echarts from 'echarts'
import less from 'less'
import getDate from './assets/utils/time'
Vue.prototype.time = getDate
Vue.prototype.storage = storage
Vue.prototype.$message = Message
import resource from './service/resource-service'
Vue.prototype.http = {
  resource: resource
}
Vue.use(less)
console.log(storage)
import VDistpicker from 'v-distpicker'
import './assets/css/base.css'
import './assets/css/theme.css'
import { applyTheme, getTheme } from './service/theme-service'
import { resumePlatformTokenRefresh } from './service/platform-token-bridge'
applyTheme(getTheme(), false)
resumePlatformTokenRefresh()
Vue.config.productionTip = false
Vue.prototype.$axios = http;
Vue.prototype.$echarts = echarts;
Vue.use(VDistpicker)
Vue.use(elementui)
let vm = new Vue({
  router,
  components: {
    App
  },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js